import { Avatar } from '../components/avatar'

type PilotLike = {
  name?: string
  avatar?: string
  profile_picture_id?: string | null
}

export function pilotInitials(name?: string): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function pilotAvatarSrc(pilot?: PilotLike): string | undefined {
  if (pilot?.profile_picture_id) return `/v0/media/${pilot.profile_picture_id}`
  return pilot?.avatar || undefined
}

type PilotAvatarProps = {
  pilot?: PilotLike
  className?: string
}

export function PilotAvatar({ pilot, className }: PilotAvatarProps) {
  return (
    <Avatar
      src={pilotAvatarSrc(pilot)}
      initials={pilotInitials(pilot?.name)}
      alt={pilot?.name ?? ''}
      className={className}
    />
  )
}
